import request from '@/utils/request'
import { getMp } from './poster'

// 查询
export function fetchBill(params) {
  if (getMp() === 'taofeng' || getMp() === 'jinduo_new') {
    return request({
      url: `/api/waiters/integral/count`,
      method: 'get',
      params
    })
  }
  return request({
    url: `/server/user_bill/dataStatistics`,
    method: 'get',
    params
  })
}
